<form [formGroup]="form" (ngSubmit)="accept()" novalidate>
    <div class="modal-header">
        <h4 class="modal-title">Detalle Llaves</h4>
        <button type="button" class="close" aria-label="Close" (click)="dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="row">

            <div class="form-group col-md-12">
                <label for="longitud">Longitud</label>
                <select class="form-control" id="longitud" formControlName="longitud"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.longitud.errors }">
                    <div *ngIf="submitted && form.controls.longitud.errors" class="invalid-feedback">
                        <div *ngIf="form.controls.longitud.errors.required">Campo requerido</div>
                    </div>
                    <option *ngFor="let item of comboLongitudes" [ngValue]="item">{{item.nombre}}</option>
                </select>
            </div>

            <div class="form-group col-md-12" *ngIf="modo===2">
                <label for="llavePublica">Llave Pública
                    <a [routerLink]="" title="Copiar" class="table-btn-row custom-icon">
                        <i [ngxClipboard]="llavePublica" (cbOnSuccess)="copy($event)" class="fa fa-clipboard"
                            aria-hidden="true"></i>
                    </a>
                </label>
                <textarea #llavePublica rows="5" readonly="true" class="form-control" id="llavePublica"
                    formControlName="llavePublica"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.llavePublica.errors }">
                </textarea>
                <div *ngIf="submitted && form.controls.llavePublica.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.llavePublica.errors.required">Campo requerido</div>
                </div>
            </div>

            <div class="form-group col-md-12" *ngIf="modo!==2">
                <label for="llavePublica">Llave Pública</label>
                <textarea #llavePublica rows="5" readonly="true" class="form-control" id="llavePublica"
                    appBlockCopyPaste formControlName="llavePublica"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.llavePublica.errors }">
                </textarea>
                <div *ngIf="submitted && form.controls.llavePublica.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.llavePublica.errors.required">Campo requerido</div>
                </div>
            </div>

            <div class="form-group col-md-12" *ngIf="modo===2">
                <label for="llavePrivada">Llave Privada
                    <a [routerLink]="" title="Copiar" class="table-btn-row custom-icon">
                        <i [ngxClipboard]="llavePrivada" (cbOnSuccess)="copy($event)" class="fa fa-clipboard"
                            aria-hidden="true"></i>
                    </a>
                </label>
                <textarea #llavePrivada rows="5" readonly="true" class="form-control" id="llavePrivada"
                    formControlName="llavePrivada"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.llavePrivada.errors }">
                </textarea>
                <div *ngIf="submitted && form.controls.llavePrivada.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.llavePrivada.errors.required">Campo requerido</div>
                </div>
            </div>

            <div class="form-group col-md-12" *ngIf="modo!==2">
                <label for="llavePrivada">Llave Privada</label>
                <textarea #llavePrivada rows="5" readonly="true" class="form-control" id="llavePrivada"
                    appBlockCopyPaste formControlName="llavePrivada"
                    [ngClass]="{ 'is-invalid': submitted && form.controls.llavePrivada.errors }">
                </textarea>
                <div *ngIf="submitted && form.controls.llavePrivada.errors" class="invalid-feedback">
                    <div *ngIf="form.controls.llavePrivada.errors.required">Campo requerido</div>
                </div>
            </div>

            <div class="form-group col-md-12" *ngIf="modo===2">
                <div class="col-md-12 text-center">
                    <button type="button" class="btn btn-info col-md-4" (click)="generateKeys()">
                        <i class="fa fa-key"></i>
                        Generar Llaves
                    </button>
                </div>
            </div>

            <div class="form-group col-md-12" *ngIf="modo===2">
                <div class="col-md-12 text-center">
                    <button type="button" class="btn btn-info btn-fidelis col-md-4"
                        (click)="downloadKeyFile(form.controls.llavePublica.value, 'LlavePublica.txt')">
                        <i class="fa fa-download"></i>
                        Descargar Llave Pública
                    </button>
                    <button type="button" class="btn btn-info btn-fidelis col-md-4"
                        (click)="downloadKeyFile(form.controls.llavePrivada.value, 'LlavePrivada.txt')">
                        <i class="fa fa-download"></i>
                        Descargar Llave Privada
                    </button>
                </div>
            </div>
        </div>

        <div class="modal-footer full-width col-md-12">
            <div class="col-md-12 text-center">
                <button type="button" class="btn btn-danger btn-fidelis col-md-4" (click)="dismiss()">
                    <i class="fa fa-times-circle"></i>
                    Cancelar
                </button>
                <button type="submit" class="btn btn-success btn-fidelis col-md-4">
                    <i class="fa fa-check-circle"></i>
                    Aceptar
                </button>
            </div>
        </div>

    </div>
</form>